import styled from 'styled-components';

export const StyledContinuouslyUsedMedicineCheckContainer = styled.div`
   min-width: 20px;
   display: flex;
   justify-content: center;
   flex-shrink: 0;
`;

StyledContinuouslyUsedMedicineCheckContainer.displayName = 'StyledContinuouslyUsedMedicineCheckContainer';
